import React from "react";
import { Card, Statistic } from "antd";
import { DollarOutlined } from "@ant-design/icons";

const TotalSalesCard = ({ value }) => {
  return (
    <Card className="dashboard-card">
      <div className="">
        
          <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">TOTAL SALES</h5>
          <div className="icon-box purple">
          
          <DollarOutlined />
        </div>
          </div>
          
         
          <Statistic 
            value={value} 
            precision={2} 
            prefix="$" 
            valueStyle={{ color: "#6f42c1", fontWeight: "bold", fontSize: "24PX" }}
          />
        
       
      </div>
    </Card>
  );
};

export default TotalSalesCard;
